<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Compliance',
})
</script>
<template>
  <div class="problem-box">
    <div class="problem-box-bg"></div>
    <div class="problem-page">
      <CompHeader />
      <div class="problem-page-box">
        <CompSidebar
          :list="ComplianceCenter.data"
          :default="commonString"
          @select="getSelectData"
        />
        <CompMain :id="commonString" />
      </div>
    </div>
    <div class="prob-footer"></div>
  </div>
</template>
<script setup lang="ts" name="Compliance">
import CompHeader from './components/Topheader/Index.vue'
import CompSidebar from './components/Sidebar.vue'
import CompMain from './components/CompMain.vue'
import ComplianceCenter from './ComplianceCenter.json'
import { onServerPrefetch } from 'vue'
import { SSRDataStore } from '@/store/modules/ssrData'
const useSSRDataStore = SSRDataStore()

const route = useRoute()

// tree组件的key
const commonString = ref<string>('')

//获取key
onMounted(() => {
  if (useSSRDataStore.currentPageStatus) {
    commonString.value = useSSRDataStore.currentPageData
    return
  }
  if (ComplianceCenter.data) {
    if (ComplianceCenter.data.length > 0) {
      if (route.query.id?.toString()) {
        commonString.value = route.query.id?.toString()
      } else {
        commonString.value = ComplianceCenter.data[0].id
      }
    }
  }
})

//获取key
onServerPrefetch(() => {
  useSSRDataStore.setCurrentPageStatus(false)
  if (ComplianceCenter.data) {
    if (ComplianceCenter.data.length > 0) {
      if (route.query.id?.toString()) {
        commonString.value = route.query.id?.toString()
      } else {
        commonString.value = ComplianceCenter.data[0].id
      }
      useSSRDataStore.setCurrentPageStatus(true)
      useSSRDataStore.setCurrentPageData(commonString.value)
    }
  }
})

const getSelectData = (id: string) => {
  if (commonString.value != id) {
    commonString.value = id
  }
}
</script>
<style scoped lang="scss">
.problem-box {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding-bottom: 40px;
  margin-top: 64px;
  background: rgba(247, 248, 250, 1);
  .problem-box-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 240px;
    background: linear-gradient(
      180deg,
      rgba(230, 240, 255, 1) 0%,
      rgba(247, 248, 250, 1) 100%
    );
  }
  .problem-page {
    width: 1240px;
    margin: 0 auto;
  }
  .problem-page-box {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }
  .prob-footer {
    width: 100%;
    height: 32px;
  }
}
</style>
